
export default {
    scrollToTop: true,
    data() {
        return {
            form: {
                fullName: null,
                email: null,
                phone: null,
                message: null,
                regNo: null,
            },
            //Form error variables
            errors: {
                formError: null
            },
            // Form submit variables
            submit: {
                loading: false,
                success: false,
                errored: false
            }
        };
    },
    methods: {
        // To clear the submit error message
        clearFormErrMsg() {
            this.errors.formError = null;
            this.submit.success = false;
            this.submit.errored = false;
        },
        // To reset the form after successful submit
        resetForm() {
            var self = this; //you need this because *this* will refer to Object.keys below`
            //Iterate through each object field, key is name of the object field`
            Object.keys(this.form).forEach(function (key, index) {
                if (typeof self.form[key] != ("object" || "array")) {
                    self.form[key] = null;
                }
            });
            this.$refs.registrationForm.reset();
        },
        // Validate and Submit form data to a add category
        sendMessage() {
            // Clear all submit errors before API call
            this.errors.formError = null;
            this.submit.success = false;
            this.submit.errored = false;
            // Validate all fields for making the API call, throw error and not call API if validation errors are present
            this.$refs.registrationForm.validate().then(success => {
                if (!success) {
                    // run your error code here
                    this.errors.formError =
                        "Cannot submit until errors are fixed.";
                } else {
                    // If Valid form
                    // Create formData instance to pass the data to the API
                    let formData = {
                        name: this.form.fullName,
                        email: this.form.email,
                        phone: this.form.phone,
                        regNo: this.form.regNo ? this.form.regNo : " N/A",
                        msg: this.form.message
                    }
                    // Add header for the API
                    const headers = {};
                    this.submit.loading = true;
                    // AXIOS api call to add categories api
                    let url = window.origin + "/api/contact";
                    this.$axios.post(url, formData, {
                        headers: headers
                    })
                        .then(response => {
                            // localStorage.setItem("payToken", "bearer " + response.data.token);
                            this.submit.success = true;
                            this.submit.errored = false;
                            this.resetForm();
                        })
                        .catch(error => {
                            this.submit.success = false;
                            this.submit.errored = true;
                        })
                        .finally(() => {
                            this.submit.loading = false;
                        });
                }
            });
        }
    }
}

